import React, { useState } from 'react';
import { trackAddToCart } from '../utils/metaPixel';
import { UpsellModal } from './closing/UpsellModal';
import { PainReactivation } from './closing/PainReactivation';
import { TransformationVision } from './closing/TransformationVision';
import { ValueTable } from './closing/ValueTable';
import { CTABlock } from './closing/CTABlock';
import { UrgencyBlock } from './closing/UrgencyBlock';
import { GuaranteeBlock } from './closing/GuaranteeBlock';
import { ObjectionsBlock } from './closing/ObjectionsBlock';
import { EmotionalClose } from './closing/EmotionalClose';
import { motion } from 'framer-motion';
const fadeUp = {
  hidden: {
    opacity: 0,
    y: 30
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
export function ClosingSection() {
  const [showUpsell, setShowUpsell] = useState(false);
  const handleCTAClick = () => {
    trackAddToCart();
    setShowUpsell(true);
  };
  return <>
      <UpsellModal isOpen={showUpsell} onClose={() => setShowUpsell(false)} data-id="element-184" />

      <section id="offer" className="py-24 max-sm:py-14 px-6 max-sm:px-4 bg-[#0A0A0A] text-[#E8E0D0] font-sans relative overflow-hidden border-t border-[#D4AF37]/10" data-id="element-185">
        {/* Background subtle glows */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-[#D4AF37]/5 rounded-full blur-[150px] pointer-events-none" data-id="element-186" />
        <div className="absolute bottom-0 right-0 w-[600px] h-[600px] bg-[#FF3B3B]/5 rounded-full blur-[150px] pointer-events-none" data-id="element-187" />

        <div className="max-w-4xl mx-auto relative z-10 space-y-24 max-sm:space-y-14" data-id="element-188">
          <PainReactivation data-id="element-189" />
          <TransformationVision data-id="element-190" />
          <ValueTable data-id="element-191" />
          <CTABlock onCTAClick={handleCTAClick} data-id="element-192" />
          <UrgencyBlock data-id="element-193" />
          <GuaranteeBlock data-id="element-194" />
          <ObjectionsBlock data-id="element-195" />
          <EmotionalClose data-id="element-196" />

          {/* CTA FINAL */}
          <motion.div id="final-cta" variants={fadeUp} initial="hidden" whileInView="show" viewport={{
          once: true
        }} className="flex justify-center" data-id="element-197">
            <button onClick={handleCTAClick} className="w-full max-w-xl min-h-[80px] max-sm:min-h-[64px] bg-[#D4AF37] hover:bg-[#B8962E] text-[#0A0A0A] font-black text-xl max-sm:text-lg md:text-2xl py-6 max-sm:py-4 px-8 max-sm:px-5 rounded-2xl shadow-[0_0_40px_rgba(212,175,55,0.3)] hover:shadow-[0_0_60px_rgba(212,175,55,0.5)] transition-all transform hover:scale-[1.02] active:scale-95 uppercase tracking-wide" data-id="element-198">
              ¡LO QUIERO AHORA! — $12.97
            </button>
          </motion.div>
        </div>
      </section>
    </>;
}